<template>
	<transition name="popup">
		<div v-show="show" class="popup-entity" :style="{left: `${idealLeft}px`, top: `${idealTop}px`}">
			<div
				class="content"
				:class="typeClass"
				:style="{
					borderColor: this.primaryColor,
					'--triangle-1': this.primaryColor,
				}"
			>
				<img :src="`./assets/entities_logos/colored/${logos.colored}`" alt="Logo de l'entité" class="logo" />
				<template v-if="type !== 'entity'">
					<div class="line"></div>
					<div class="description">
						<div v-if="type === 'service-name'" class="service-name">
							<h4 class="montserra-m-i fs-1-25 white">{{ serviceName }}</h4>
						</div>

						<div v-else-if="type === 'service-link'" class="service-link">
							<h4 class="montserra-m-i fs-1-25 white">{{ serviceName }}</h4>
							<p class="montserra-r fs-1 white">{{ serviceLinkDescription }}</p>
						</div>

						<div v-else-if="type === 'colaborator'" class="colaborator">
							<h5 class="montserra-m-i fs-1" :style="{color: primaryColor}">{{ colaboratorService }}</h5>
							<div class="colaborator-content">
								<div class="picture">
									<img :src="`./assets/peoples/${collabPhoto}`" alt="" />
								</div>
								<div class="info">
									<h4 class="montserra-m fs-1-25 white">{{ colaboratorName }}</h4>
									<span class="montserra-r fs-1 white">{{ colaboratorPosition }}</span>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</transition>
</template>
<style lang="scss" scoped>
	.popup-entity {
		user-select: none;
		position: absolute;
		z-index: 30;
		.content {
			border-radius: 0.5rem;
			border-top-left-radius: 0;
			border: 2px solid;
			background: var(--black-5);
			box-sizing: border-box;
			position: relative;
			max-width: 500px;
			// triangle part
			&::before,
			&::after {
				content: ' ';
				position: absolute;
				width: 0;
				height: 0;
			}
			&::before {
				left: -2px;
				bottom: 100%;
				border: 8px solid;
				border-color: transparent transparent var(--triangle-1) var(--triangle-1);
			}
			&::after {
				left: 0px;
				bottom: 100%;
				border: 6px solid;
				border-color: transparent transparent var(--black-5) var(--black-5);
			}

			&.type-entity {
				padding: 1.5rem 1rem;
			}
			&.type-regular {
				.logo {
					margin-top: auto;
					margin-bottom: auto;
				}
				padding: 0.5rem 1rem;
			}
			.logo {
				height: 2.5rem;
			}

			display: flex;
			flex-direction: row;
			align-items: stretch;
			.line {
				background-color: var(--white);
				width: 2px;
				margin: 0 1rem;
			}
			.description {
				box-sizing: border-box;
				.service-name {
					display: flex;
					align-items: center;
					height: 100%;
				}
				.service-link {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;

					p {
						margin-top: 0.5rem;
					}
				}
				.colaborator {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;

					.colaborator-content {
						margin-top: 0.25rem;
						display: flex;
						flex-direction: row;
						align-items: center;
						.picture {
							flex-grow: 1;
							min-width: 3.375rem;
							min-height: 3.375rem;
							max-width: 3.375rem;
							max-height: 3.375rem;
							border-radius: 50%;
							overflow: hidden;
							img {
								width: 100%;
								height: 100%;
							}
							margin-right: 0.5rem;
						}
						.info {
							flex-shrink: 1;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
						}
					}
				}
			}
		}
	}
	//popup transition
	.popup-enter-active {
		transition: opacity 0.6s;
	}
	.popup-enter {
		opacity: 0;
	}
</style>
<script>
	import {mapState} from 'vuex';
	export default {
		props: {
			left: Number,
			top: Number,
			show: Boolean,

			// popup type
			/**
			 *   entity
			 *   service-name
			 *   service-link
			 *   colaborator
			 */
			type: {
				require: false,
				type: String,
				default: '',
			},

			// data
			logos: {
				// getting all the logos
				require: false,
				type: Object,
				default: () => {},
			},
			primaryColor: {
				require: false,
				type: String,
				default: '#fff',
			},
			serviceName: {
				require: false,
				type: String,
				default: '',
			},
			serviceLinkDescription: {
				require: false,
				type: String,
				default: '',
			},

			colaboratorService: {
				require: false,
				type: String,
				default: '',
			},
			colaboratorName: {
				require: false,
				type: String,
				default: '',
			},
			colaboratorPosition: {
				require: false,
				type: String,
				default: '',
			},
			colaboratorPicture: {
				require: false,
				type: String,
				default: '',
			},
		},
		computed: {
			...mapState(['currentZoom']),
			typeClass() {
				switch (this.type) {
					case 'entity':
						return 'type-entity';
					case 'service-name':
					case 'service-link':
					case 'colaborator':
					default:
						return 'type-regular';
				}
			},
			idealLeft() {
				return this.left + 10;
			},
			idealTop() {
				return this.top + 10;
			},
			collabPhoto() {
				return this.colaboratorPicture.trim() === '' ? 'default.png' : this.colaboratorPicture;
			},
		},
	};
</script>
